import { type WorkflowData, type WorkflowListInput, type WorkflowListSuccess } from '@terros/common'
import { workflowListKey } from '../workflow/keys'
import { useTantalimQuery } from '../query'
import { type GetHookResponse } from '../hooks'

export function useRecordingReviewWorkflows(): GetHookResponse<WorkflowData[]> {
  const input: WorkflowListInput = { archived: 'all' }
  return useTantalimQuery<WorkflowListInput, WorkflowListSuccess, WorkflowData[]>({
    url: '/workflow/list',
    input,
    queryKey: [...workflowListKey(input), 'recording-review'],
    convertResponse: ({ workflows, readonly }) => [...workflows, ...readonly],
    options: { staleTime: 0 },
  })
}
